import { RequestsApi } from './requests';
import { UserSummariesApi } from './userSummaries';
import {
  DashboardAPI,
  AxiosDashboardAPI,
} from 'api/normalized/dashboard/dashboardAPI';
import {
  CardTypeApi,
  AxiosCardTypeApi,
} from 'state/Insights/charts/cardTypeApi';
import { FormSummariesApi } from './formSummaries';
import { ProjectSummariesApi } from './projectSummaries';
import { ProjectPermissionsApi } from './projectPermissions';
import { BusinessUnitSummariesApi } from './businessUnitSummaries';
import { RequestPermissionsApi } from './requestPermissions';
import { EventPermissionsApi } from './eventPermissions';
import { ProgramPermissionsApi } from './programPermissions';
import InsightDataApi from 'api/normalized/insight/InsightDataApi';
import insightFiltersAPI from 'api/normalized/insight/insightFiltersAPI';
import InsightDrilldownApi from 'api/normalized/insightDrilldown/InsightDrilldownApi';
import LearningTeamsApi from './learningTeams';
import ProjectTemplatesApi from './projectTemplates';
import { AgentDashboardApi } from 'api/normalized/agentDashboard/agentDashboardAPI';

export class BaseApiFactory {
  private static requestsApi: RequestsApi;
  private static userSummariesApi: UserSummariesApi;
  private static formSummariesApi: FormSummariesApi;
  private static projectSummariesApi: ProjectSummariesApi;
  private static projectPermissionsApi: ProjectPermissionsApi;
  private static businessUnitSummariesApi: BusinessUnitSummariesApi;
  private static requestPermissionsApi: RequestPermissionsApi;
  private static eventPermissionsApi: EventPermissionsApi;
  private static programPermissionsApi: ProgramPermissionsApi;
  private static insightDataApi: InsightDataApi;
  private static insightFiltersApi: insightFiltersAPI;
  private static insightDrilldownApi: InsightDrilldownApi;
  private static learningTeamsApi: LearningTeamsApi;
  private static projectTemplatesApi: ProjectTemplatesApi;
  private static agentDashboardApi: AgentDashboardApi;

  private constructor() {}

  static getRequestsApi(): RequestsApi {
    if (!this.requestsApi) {
      this.requestsApi = new RequestsApi();
    }
    return this.requestsApi;
  }

  static getUserSummariesApi(): UserSummariesApi {
    if (!this.userSummariesApi) {
      this.userSummariesApi = new UserSummariesApi();
    }
    return this.userSummariesApi;
  }

  static getDashboardApi(): DashboardAPI {
    return new AxiosDashboardAPI();
  }

  static getAgentDashboardApi(): AgentDashboardApi {
    if (!this.agentDashboardApi) {
      this.agentDashboardApi = new AgentDashboardApi();
    }
    return this.agentDashboardApi;
  }

  static getCardTypeApi(): CardTypeApi {
    return new AxiosCardTypeApi();
  }

  static getFormSummariesApi(): FormSummariesApi {
    if (!this.formSummariesApi) {
      this.formSummariesApi = new FormSummariesApi();
    }
    return this.formSummariesApi;
  }

  static getProjectSummariesApi(): ProjectSummariesApi {
    if (!this.projectSummariesApi) {
      this.projectSummariesApi = new ProjectSummariesApi();
    }
    return this.projectSummariesApi;
  }

  static getProjectPermissionsApi(): ProjectPermissionsApi {
    if (!this.projectPermissionsApi) {
      this.projectPermissionsApi = new ProjectPermissionsApi();
    }
    return this.projectPermissionsApi;
  }

  static getBusinessUnitsApi(): BusinessUnitSummariesApi {
    if (!this.businessUnitSummariesApi) {
      this.businessUnitSummariesApi = new BusinessUnitSummariesApi();
    }
    return this.businessUnitSummariesApi;
  }

  static getRequestPermissionsApi(): RequestPermissionsApi {
    if (!this.requestPermissionsApi) {
      this.requestPermissionsApi = new RequestPermissionsApi();
    }
    return this.requestPermissionsApi;
  }

  static getEventPermissionsApi(): EventPermissionsApi {
    if (!this.eventPermissionsApi) {
      this.eventPermissionsApi = new EventPermissionsApi();
    }
    return this.eventPermissionsApi;
  }

  static getProgramPermissionsApi(): ProgramPermissionsApi {
    if (!this.programPermissionsApi) {
      this.programPermissionsApi = new ProgramPermissionsApi();
    }
    return this.programPermissionsApi;
  }
  static getInsightDataApi(): InsightDataApi {
    if (!this.insightDataApi) {
      this.insightDataApi = new InsightDataApi();
    }
    return this.insightDataApi;
  }
  static getInsightDrilldownApi(): InsightDrilldownApi {
    if (!this.insightDrilldownApi) {
      this.insightDrilldownApi = new InsightDrilldownApi();
    }
    return this.insightDrilldownApi;
  }
  static getInsightFiltersApi(): insightFiltersAPI {
    if (!this.insightFiltersApi) {
      this.insightFiltersApi = new insightFiltersAPI();
    }
    return this.insightFiltersApi;
  }

  static getLearningTeamsApi(): LearningTeamsApi {
    if (!this.learningTeamsApi) {
      this.learningTeamsApi = new LearningTeamsApi();
    }
    return this.learningTeamsApi;
  }

  static getProjectTemplatesApi(): ProjectTemplatesApi {
    if (!this.projectTemplatesApi) {
      this.projectTemplatesApi = new ProjectTemplatesApi();
    }
    return this.projectTemplatesApi;
  }
}
